/**
 * Formats a date string to "MMM D, YYYY" (e.g., "May 5, 2025").
 * Returns the fallback value if dateString is falsy.
 */
const formatDate = (dateString, fallback = "-") => {
  if (!dateString) return fallback;
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return fallback;
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

export default formatDate;
